var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.16667C8.38917 4.16667 7.08333 5.4725 7.08333 7.08333C7.08333 8.69416 8.38917 10 10 10C11.6108 10 12.9167 8.69416 12.9167 7.08333C12.9167 5.4725 11.6108 4.16667 10 4.16667ZM5.41667 7.08333C5.41667 4.55203 7.46869 2.5 10 2.5C12.5313 2.5 14.5833 4.55203 14.5833 7.08333C14.5833 9.61464 12.5313 11.6667 10 11.6667C7.46869 11.6667 5.41667 9.61464 5.41667 7.08333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.6667C6.77834 11.6667 4.16667 14.2783 4.16667 17.5C4.16667 17.9602 3.79357 18.3333 3.33333 18.3333C2.8731 18.3333 2.5 17.9602 2.5 17.5C2.5 13.3579 5.85786 10 10 10C14.1421 10 17.5 13.3579 17.5 17.5C17.5 17.9602 17.1269 18.3333 16.6667 18.3333C16.2064 18.3333 15.8333 17.9602 15.8333 17.5C15.8333 14.2783 13.2217 11.6667 10 11.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b049a037b5b80562c98e923746d8aea6.svg";
export { ForwardRef as ReactComponent };